import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { PreReadService } from 'src/app/core/services/pre-read.service';

export interface LegalInformationDeleteConfirmationData {
  preReadId: string;
 
  hasSharedLawyers: boolean;
}

@Component({
  selector: 'app-legal-information-delete-confirmation-dialog',
  templateUrl: './legal-information-delete-confirmation-dialog.component.html',
  styleUrls: ['./legal-information-delete-confirmation-dialog.component.css'],
  standalone: false
})
export class LegalInformationDeleteConfirmationDialogComponent {

  deleting = false;
  errorMessage = '';

  constructor(
    private dialogRef: MatDialogRef<LegalInformationDeleteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LegalInformationDeleteConfirmationData,
    private preReadService: PreReadService
  ) { }

  onCancel(): void {
    if (this.deleting) { return; }
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    if (this.deleting || !this.data?.preReadId) { return; }

    this.deleting = true;
    this.errorMessage = '';

    this.preReadService.deleteDraft(this.data.preReadId).pipe(
      finalize(() => this.deleting = false)
    ).subscribe({
      next: () => this.dialogRef.close(true),
      error: () => {
        this.errorMessage = 'Could not delete this Legal Information entry. Please try again.';
      }
    });
  }
}